<template>
    <div class="layer-list-root">
    <div class="layer-list-container" v-if="selectedRelease">
        <div class="data-panel">
            <b-row no-gutters class="mb-2">
                <b-col cols="12">
                    <button class="change-region-btn" title="Change Dataset" @click="$bvModal.show('ptvReleaseModal')">
                        <svg class="change-region-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="1.2"/>
                            <path d="M8 1.5C8 1.5 10.5 4 10.5 8S8 14.5 8 14.5M8 1.5C8 1.5 5.5 4 5.5 8S8 14.5 8 14.5M1.5 8h13" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
                        </svg>
                        <span>Change Region</span>
                    </button>
                </b-col>
            </b-row>
            <b-row >
                <b-col class="layer-list-font">{{ this.getFormattedDate(selectedRelease.release_date) }} - {{ selectedRelease.extent_description }}</b-col>
            </b-row>
            <b-row  >
                <b-col  class="layer-list-font">{{ selectedRelease.release_label }}</b-col>
            </b-row>
        </div>
        <div class="layers">
            <draggable>
                <transition-group type="transition" name="flip-list">
                    <b-row
                        v-for="(element, index) in layerButtons"
                        :key="element.name"
                        :id="element.name.replace(/\s+/g, '_')"
                        class="layer-row"
                        :class="getLayerClass(index, element)"
                    >
                        <b-col
                          cols="8"
                          class="layer-btn"
                          @click="toggleLayer(element, $event)"
                        >
                            <span class="layer-row-label">{{ capitalizeFirstLetter(element.display_name ? element.display_name : element.name) }}</span>
                        </b-col>
                        <b-col cols="4" class="layer-arrow layer-arrow--end">
                            <fa
                              @click="toTopOfList(element.display_name ? element.display_name : element.name)"
                              title="Move Layer To Top"
                              :icon="['fas', 'long-arrow-alt-up']"
                              class="cursor"
                            />
                        </b-col>
                    </b-row>
                </transition-group>
            </draggable>
        </div>
    </div>
    <TRT_TrailGroups
      v-if="showTrailsPanel"
      :lidarMinZoomAchieved="lidarMinZoomAchieved"
      :showTrailsPanel="showTrailsPanel"
      :distinct_trails="distinct_trails"
      :extentName="selectedExtent"
      :trailsLoading="trailsLoading"
      :map="map"
      :selectedExtent="selectedExtent"
      :zoomLevel="zoomLevel"
      :selectedTrails="selectedTrails"
      :cart="cart"
      :disableTrailGroups="disableTrailGroups"
      @onPointcloudClick="$emit('onPointcloudClick', $event)"
    ></TRT_TrailGroups>
     <!-- <MMP_LayerLegend
        v-if="mapsMode && layerLegend"
        id="layerLegend"
        class="layer-legend-position p-1 mt-2"
        :layerLegendMaxHeight="layerLegendMaxHeight"
        :layerLegendName="layerLegendName"
        :legendImgSrc="legendImgSrc"
        :legendMinimized="layerLegendMinimized"
        @closeLegend="closeLegend()"
        @maximizeLegend="maxOrMinLegend(false)"
        @minimizeLegend="maxOrMinLegend(true)"
    ></MMP_LayerLegend> -->
    </div>
</template>
<style src="./Data_Tools.css" scoped></style>
<style scoped>
.layer-list-root {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    min-height: 0;
    overflow: hidden;
}

.layer-list-container {
    /* border: 2px solid #063c6d; */
    width: 14.375rem;
    border-radius: 5px;
    overflow: hidden;
    flex-shrink: 0;
}
.data-panel {
    width: 100%;
    background-color: #063c6d;
    color: white;
    padding: 0.4375rem;
    padding: 5%;
 }
.layer-list-font {
    font-size: 0.8125rem !important;
    font-weight: 500; 
}
.change-region-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    background: linear-gradient(135deg, rgba(32, 255, 155, 0.18) 0%, rgba(4, 150, 233, 0.15) 100%);
    border: 1.5px solid rgba(32, 255, 155, 0.6);
    border-radius: 8px;
    color: #20ff9b;
    font-size: 0.625rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    padding: 0.3125rem 0.625rem;
    cursor: pointer;
    user-select: none;
    box-shadow: 0 0 10px rgba(32, 255, 155, 0.2), inset 0 1px 0 rgba(255,255,255,0.08);
    transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
    white-space: nowrap;
    width: 100%;
    justify-content: center;
}
.change-region-btn:hover {
    background: linear-gradient(135deg, rgba(32, 255, 155, 0.32) 0%, rgba(4, 150, 233, 0.25) 100%);
    border-color: #20ff9b;
    box-shadow: 0 0 18px rgba(32, 255, 155, 0.45), 0 2px 8px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1);
    transform: translateY(-1px);
    color: #fff;
    text-shadow: 0 0 8px rgba(32, 255, 155, 0.8);
}
.change-region-btn:active {
    transform: translateY(0);
    box-shadow: 0 0 6px rgba(32, 255, 155, 0.25);
}
.change-region-icon {
    width: 0.875rem;
    height: 0.875rem;
    flex-shrink: 0;
}
.layers {
    width: 100%;
    padding: 0.5rem;
    background-color: #eef3f9;
    overflow-y: auto;
    max-height: 20.625rem;
}
.layer-btn {
    font-size: 0.75rem !important;
    font-weight: 500;
    width: 100%;
    padding: 0.375rem 0.625rem !important;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.625rem;
    min-width: 0;
    color: #063c6d;
}
.layer-row-label {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.layer-arrow {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
    color: #063c6d;
    cursor: pointer !important;
}
.layer-arrow--end {
    justify-content: flex-end;
    padding-right: 0.75rem;
}
.layer-row {
    padding: 0 !important;
    margin: 0 0 0.5rem;
    width: 100%;
    min-height: 2.75rem;
    background-color: #ffffff;
    border: 1px solid rgba(6, 60, 109, 0.1);
    border-radius: 10px;
    box-shadow: 0 1px 3px rgba(6, 60, 109, 0.06);
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease, background-color 0.2s ease, border-color 0.2s ease;
}
.layer-row:last-child {
    margin-bottom: 0;
}
.layer-row:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(6, 60, 109, 0.14);
    border-color: rgba(6, 60, 109, 0.2);
}
.available-not-enabled {
  background-color: #ffffff;
}
.available-enabled {
  /* background-color: #eaf7ef; */
    background-color: #c4ead2;
  box-shadow: inset 3px 0 0 #1f9d55;
}
.unavailable {
  background-color: #eef1f4;
  opacity: 0.55;
  cursor: not-allowed;
}
.unavailable .layer-btn {
  cursor: not-allowed;
  pointer-events: none;
}
</style>
<script>
import draggable from 'vuedraggable'
import {orderMapLayers} from './../../../utils/utils.js'
import TRT_TrailGroups from './TRT_TrailGroups.vue'

export default {
    name: 'DT_LayerList',
    props: [
        'drtLayersButtonsCtrl',
        'map',
        'ptv_layersObj',
        'selectedRelease',
        'layerResponse',
        'zoomEnded',
        'zoomLevelCap',
        'layerLegend',
        'layerLegendMaxHeight',
        'layerLegendName',
        'legendImgSrc',
        'layerLegendMinimized',
        'mapsMode',
        'showTrailsPanel',
        'lidarMinZoomAchieved',
        'distinct_trails',
        'trailsLoading',
        'selectedTrails',
        'cart',
        'zoomLevel',
        'selectedExtent',
        'disableTrailGroups'
    ],
    components: {
        draggable,
        TRT_TrailGroups
    },
    data() {
        return {
            layerButtons: []
        }
    },
    methods: {
        capitalizeFirstLetter(str) {
            if (!str) return ""; // Handle empty strings safely
            return str.replace(/\b\w/g, char => char.toUpperCase());
        },
        getFormattedDate(originalDateString) {
            let originalDateObj = new Date(originalDateString)
            let returnValue = originalDateObj.toLocaleString('en-US', {dateStyle: 'short'}).replace(/\//g, '.')
            return returnValue
        },
        getLayerClass(index, element) {
            let mapObjs = this.ptv_layersObj
            let disabled = this.checkLayerDisable(element.name, element.zoomControl, element.minZoom)
            let displaying = this.checkLayer(mapObjs[element.name].layer)

            if (!disabled && displaying) {
                // Layer isn't disabled and layer is turned on
                return 'available-enabled'
            } else if (!disabled) {
                // Layer isn't disabled and layer is turned off
                return 'available-not-enabled'
            } else {
                // Layer is disabled
                return 'unavailable'
            }
        },
        checkLayerDisable(layerName, zoomControl, minZoom) {
            /* checkLayerDisable method returns true if zoomControl is
            enabled and the user is zoomed in far enough. */
            this.$emit('updateZoomEnded', this.map.getView().getZoom())
            let returnClass = false
            let layerExists = this.ptv_layersObj[layerName] != null
            let showLayer =
                minZoom == null
                ? this.zoomEnded >= this.zoomLevelCap
                : this.zoomEnded >= minZoom

            if (layerExists) {
                const layerObj = this.ptv_layersObj[layerName].layer
                if (!this.checkLayer(layerObj)) {
                    /* returnClass is true if zoomControl is enabled on the
                    layer and the user is zoomed in far enough. */
                    returnClass = zoomControl && !showLayer
                }
            }

            return returnClass
        },
        checkLayer(layer) {
            // Checks if layer exists on the map
            let exists = false
            let mapLayersArr = this.map.getLayers().getArray()

            switch (typeof layer) {
                case 'object':
                    for (let i in mapLayersArr) {
                        // If layer exists, return true
                        exists = mapLayersArr[i] === layer
                        if (exists) {
                            break
                        }
                    }
                    break
                case 'string':
                    for (let i in mapLayersArr) {
                        // If layer exists, return true
                        exists =
                            mapLayersArr[i].values_.hasOwnProperty('name') &&
                            mapLayersArr[i].values_.name === layer
                        if (exists) {
                            break
                        }
                    }
                    break
            }

            return exists
        },
        toggleLayer(element, event) {
            let disabled = this.checkLayerDisable(
                element.name,
                element.zoomControl,
                element.minZoom
            )
            let layerName = element.name
            if (!disabled) {
                this.$emit('toggleLayerVisibility', layerName)
                this.onEnd()
            }

            event.target.blur();
        },
        onEnd() {
            let mapObjs = this.ptv_layersObj
            orderMapLayers(mapObjs, this.layerButtons, this.map)
            this.map.getLayers().forEach(layer => {
                if (layer && layer.get('name') == this.layerButtons[0].name) {
                {
                    this.$emit('loadAttributes', {
                        name: this.layerButtons[0].name,
                        layer_group: this.layerButtons[0].layer_group,
                        response: this.layerResponse
                    })
                    this.$emit('getShowAttributes', false)
                }
                }
            })
            this.$emit('layerButtonsChanged', this.layerButtons)
            // this.initFilterClasses()
        },
        closeLegend() {
            this.$emit('closeLegend')
        },
        maxOrMinLegend(bool) {
            if (bool) {
                this.$emit('minimizeLegend')
            } else {
                this.$emit('maximizeLegend')
            }
        },
        toTopOfList(elementName) {
            let tool = 'DRT'

            return new Promise((resolve) => {
                this.$emit('toTopOfList', { payload: { layerName: elementName, tool }, resolve })
            }).then(() => {
                this.onEnd()
            })
        },
    },
    watch: {
        drtLayersButtonsCtrl: function (newValue, oldValue) {
            this.layerButtons = newValue
        },
    }
}
</script> 